module.exports = __webpack_public_path__ + "img/icom_wjxrw.d82abd74.png";